import React from 'react';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import { Input, FormField } from 'semantic-ui-react';

import Field from './Field';

const DateTimeInput = ({
  value,
  onChange,
  errors,
  touched,
  text,
  name,
  disabled
}) => {
  const updateDate = date =>
    onChange(null, {
      name,
      value: moment(date).isValid() ? date.format('YYYY-MM-DDTHH:mm:ss') : null
    });
  return (
    <Field error={errors} touched={touched}>
      <FormField
        className="c-DatePicker__wrapper c-DatePicker__wrapper--filters"
        disabled={disabled}
      >
        <label>{text}</label>
        <DatePicker
          isClearable={true}
          name={name}
          showTimeSelect
          placeholderText={text}
          dateFormat="DD/MM/YYYY LT"
          timeFormat="LT"
          timeIntervals={15}
          selected={value && moment.utc(value, 'YYYY-MM-DDTHH:mm:ss')}
          onChange={date => updateDate(date)}
          onChangeRaw={({ target }) => {
            const date = moment(target.value, 'DD/MM/YYYY LT');
            updateDate(date);
          }}
          popperModifiers={{
            preventOverflow: {
              enabled: true,
              escapeWithReference: false
            }
          }}
          showMonthDropdown
          showYearDropdown
          customInput={<Input style={{ width: '100%' }} />}
        />
      </FormField>
    </Field>
  );
};

export default DateTimeInput;



// WEBPACK FOOTER //
// ./src/component/DateTimeInput.js